/** Internal keys for intake clarify chips — labels live in commonIntakePage.clarify.* */
export const CLARIFY_CHIP_KEYS = [
  'chipRevenueDecline',
  'chipCostPressure',
  'chipOperationalInefficiency',
  'chipLeadership',
  'chipMarket',
  'chipOther',
] as const;

export type ClarifyChipKey = (typeof CLARIFY_CHIP_KEYS)[number];

const CHIP_KEY_SET = new Set<string>(CLARIFY_CHIP_KEYS);

export function isClarifyChipKey(value: string): value is ClarifyChipKey {
  return CHIP_KEY_SET.has(value);
}
